import axios from "axios";


function configureConfigurationAPI(options) {
    const apiUrl = `${options.baseUrl}/configuration`;

    return {
        async getYearDevis() {
            const response = await axios.get(`${apiUrl}/get-year-devis`);
            return response.data;
        }
    };
}

export { configureConfigurationAPI };